import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import InputWithValidation from '../../../components/forms/InputWithValidation'
import SelectWithValidation from '../../../components/forms/SelectWithValidation'
import TaskResult from '../../../models/TaskResult'
import { findOption } from '../../../utils/Select'

const ProjectPaymentFilters = ({ filters, handleFilterChange, handleClearFilters }) => {
  const statusOptions = TaskResult.getPaymentStatusOptions();
  const statusDefaultOption = findOption(statusOptions, filters['status']);

  return (
    <>
      <div className='tw-relative tw-my-4 '>
        <span className='tw-font-medium tw-text-lg'>Filters</span>
        <div
          className='tw-flex tw-items-center tw-justify-center tw-absolute tw-top-0 tw-right-0 tw-w-8 tw-h-8 tw-rounded tw-bg-[#fff] tw-border tw-border-solid tw-border-gray-300 tw-cursor-pointer hover:tw-bg-gray-100 tw-transition-all tw-ease-in-out tw-duration-200'
          onClick={handleClearFilters}
        >
          <FontAwesomeIcon icon={faTrashCan} className='tw-text-[20px]' />
        </div>
      </div>
      <div className='tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-x-2'>
        <InputWithValidation
          propertyName='id'
          label='Payment ID'
          placeholder='Payment ID'
          defaultValue={filters.id ?? ''}
          onChange={handleFilterChange}
        />
        <InputWithValidation
          label='Worker Username'
          propertyName='user.sid'
          placeholder='Worker Username'
          defaultValue={filters['user.sid'] ?? ''}
          onChange={handleFilterChange}
        />
        <SelectWithValidation
          label='Status'
          placeholder='Status'
          propertyName='status'
          isMulti={true}
          isSearchable={true}
          options={statusOptions}
          defaultOption={statusDefaultOption}
          onChange={handleFilterChange}
        />
      </div>
    </>
  );
}
export default ProjectPaymentFilters;